import React, { useState } from 'react';
import { H } from '../Layout';
import { SvgIconComponent } from '@mui/icons-material';
import ButtonWithIcon from './ButtonWithIcon';
import { SxProps } from '@mui/material';

type ButtonWithIconGroupProps = {
    labels: Array<string>;
    onClick: (index: number) => void;
    setIcon: (index: number) => SvgIconComponent;
    containSelectedButton?: boolean;
    defaultSelectedButtonIndex?: number;
    sx?: SxProps;
    disabled?: boolean;
};

export default ({
    labels,
    onClick,
    setIcon,
    containSelectedButton = false,
    defaultSelectedButtonIndex = null,
    sx = undefined,
    disabled = false
}: ButtonWithIconGroupProps) => {
    const [selectedButtonIndex, setSelectedButtonIndex] = useState<number>(defaultSelectedButtonIndex);

    const onButtonClicked = (index: number) => {
        onClick(index);
        if (containSelectedButton) {
            setSelectedButtonIndex(index === selectedButtonIndex ? null : index);
        }
    };

    return (
        <H gap={1} sx={{ alignItems: 'flex-start', flexWrap: 'wrap', ...sx }}>
            {labels.map((name: string, index: number) => (
                <ButtonWithIcon
                    key={index}
                    label={name}
                    onClick={() => onButtonClicked(index)}
                    Icon={setIcon(index)}
                    buttonContained={containSelectedButton ? selectedButtonIndex === index : false}
                    sx={{ alignItems: 'flex-start', width: 'auto' }}
                    disabled={disabled}
                />
            ))}
        </H>
    );
};
